import * as React from 'react';
import { Loading, Collapse, Input, Row, Col, CheckBox, Divider } from 'sha-el-design';
import { GraphqlQuery } from 'requestapijs';
import {
  TownNodeConnection, StateNode, TownNode,
  UserDetailNode, AreaNode,
} from '../../../schema';
import { townDropdownQuery } from '../Common/constants';
import { FaSearch } from 'react-icons/fa';
import { AreaDropdown } from '../Common/AreaDropdown';
import * as moment from 'moment';

export class SelectTown extends React.Component<Props, State> {
  static defaultProps = {
    extrafields: [],
  };

  constructor(props) {
    super(props);

    this.state = {
      searchQuery: '',
      isTownOpen: {},
      toShowWithZeroRetailer: true,
    };
  }

  onTownSelect = (selected: boolean, town: TownNode) => {
    const { towns, onTownSelect } = this.props;

    if (selected) {
      const newTowns = [...towns, town];
      return onTownSelect(newTowns);
    }

    const updatedTowns = [...towns];
    updatedTowns.splice(updatedTowns.findIndex((v) => v.id === town.id), 1);
    onTownSelect(updatedTowns);
  }

  // Keyed by town id, not array position. It used to be an array indexed by
  // the position in the SEARCH-FILTERED list, so expanding a town and then
  // typing in Search Town left a *different* town rendered as expanded.
  onCollapseClick = (townId: string) => {
    this.setState((s) => ({
      isTownOpen: { ...s.isTownOpen, [townId]: !s.isTownOpen[townId] },
    }));
  }

  isTownSelected = (town: AreaNode) => {
    const { towns } = this.props;
    if (towns.find((v) => v.id === town.id)) {
      return true;
    }
    return false;
  }

  render() {
    return (
      <GraphqlQuery
        queryString={townDropdownQuery}
        variables={{
          name: this.state.searchQuery,
          selectedState: this.props.state.id,
          updateTownCount: this.props.updateTownCount,
        }}
        render={(response: { allTowns: TownNodeConnection }, error, loading) => {
          if (error) {
            return <h3>Something went wrong</h3>;
          }
          return (
            <Loading
              isLoading={loading || !response}
              render={() => (
                <div>
                  <div className='cs-wiz__townbar'>
                    <div className='cs-wiz__townbar-search'>
                      <Input
                        placeholder='Search Town'
                        value={this.state.searchQuery}
                        onChange={(e) => this.setState({ searchQuery: e.target.value })}
                        after={
                          <FaSearch />
                        }
                      />
                    </div>
                    <CheckBox
                      onChange={(e) => this.setState({ toShowWithZeroRetailer: !this.state.toShowWithZeroRetailer })}
                      checked={this.state.toShowWithZeroRetailer}
                      type='checkbox'
                      label='Include towns with 0 retailers'
                    />
                  </div>
                  <Divider />

                  {response.allTowns && response.allTowns.edges.filter((town) => {
                    if (!this.state.toShowWithZeroRetailer) {
                      return ((town.node.retailerCount !== 0) && !town.node.assigned);
                    }
                    return !town.node.assigned;
                  }).map((value) => (
                    <Collapse
                      key={value.node.id}
                      header={
                        // Was three <Col>s rendering "No Of Retailers:42" with
                        // no separator and a raw lastCallDate. Now the town
                        // name leads and its facts are scannable pills.
                        <div
                          className={
                            'cs-wiz__town' +
                            (this.isTownSelected(value.node) ? ' cs-wiz__town--selected' : '')
                          }
                        >
                          {/* The CheckBox sits inside the Collapse header, so
                              its click bubbled up and toggled the panel open
                              or shut every time a town was ticked. The old
                              zIndex: 10001 was a stacking hack that cannot
                              stop propagation. */}
                          <span
                            className='cs-wiz__town-check'
                            onClick={(e) => e.stopPropagation()}
                          >
                            <CheckBox
                              onChange={(e) => this.onTownSelect(e.target.checked, value.node)}
                              checked={this.isTownSelected(value.node)}
                              type='checkbox'
                              label={value.node.name}
                            />
                          </span>
                          <span className='cs-wiz__town-meta'>
                            <span
                              className={
                                'cs-wiz__pill ' +
                                (value.node.retailerCount ? 'cs-wiz__pill--count' : 'cs-wiz__pill--empty')
                              }
                              title='Retailers in this town'
                            >
                              {value.node.retailerCount} {value.node.retailerCount === 1 ? 'retailer' : 'retailers'}
                            </span>
                            <span className='cs-wiz__pill' title='Last call made in this town'>
                              {value.node.lastCallDate
                                ? `Last call ${moment(value.node.lastCallDate).format('DD MMM YYYY')}`
                                : 'Never called'}
                            </span>
                          </span>
                        </div>
                      }
                      onChange={() => this.onCollapseClick(value.node.id)}
                      isOpen={!!this.state.isTownOpen[value.node.id]}
                    >
                      {
                        this.state.isTownOpen[value.node.id] && <AreaDropdown
                          areas={this.props.areas}
                          selectedTown={value.node}
                          onAreaSelect={this.props.onAreaSelect}
                          toShowWithZeroRetailer={this.state.toShowWithZeroRetailer}
                        />
                      }
                    </Collapse>
                  ))}
                </ div>
              )}
            />
          );
        }}
      />
    );
  }
}

interface Props {
  state: StateNode;
  towns: TownNode[];
  areas: AreaNode[];
  caller: UserDetailNode;
  onTownSelect: (towns: TownNode[]) => void;
  onAreaSelect: (areas: AreaNode[]) => void;
  updateTownCount: number;
}

interface State {
  isTownOpen: { [townId: string]: boolean };
  searchQuery: string;
  toShowWithZeroRetailer: boolean;
}
